export default __webpack_public_path__ + "static/logo-liberty-6e8615ad3cb2614d67567f1b1b22edac.png";